import { call, put, takeLeading } from 'redux-saga/effects'
import * as fromActions from '../../actions/courses.action'
import getCourseDataToDuplicate from 'api/administration/courses/GetToDuplicate'

async function handleGetCourse(courseId: number) {
  return await getCourseDataToDuplicate(courseId)
}

function* getCourseEffectSaga(action: any) {
  try {
    const data = yield call(handleGetCourse, action.payload)
    yield put(fromActions.Actions.getCourseDateToDuplicateSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* getCourseDataToDuplicateWatcherSaga() {
  yield takeLeading(fromActions.GET_COURSE_DATA_TO_DUPLICATE, getCourseEffectSaga)
}
